// Types
import { RatingKeys } from '@globalTypes/index';
import { OptimizedSpeedsAsNumber, OptimizedSpeedsAsString } from '@helpers/index';

/**
 *
 * @param {number} value - Input value as a number.
 * @returns {string} - A string value parsed with locales.
 */
const parse = (value: number) =>
  Number(value ?? -1).toLocaleString('en-US', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  });

/**
 * Formats optimized speeds from numeric values to string representation with proper decimal formatting.
 *
 * @param optimizedSpeeds - Object containing optimized speed values as numbers corresponding to different ratings.
 *
 * @returns A formatted object with optimized speed values as strings or `undefined` if the input is not provided.
 */
export const formatOptimizedSpeeds = (optimizedSpeeds?: OptimizedSpeedsAsNumber) => {
  const res = {} as OptimizedSpeedsAsString;

  if (optimizedSpeeds) {
    for (const rating in optimizedSpeeds) {
      res[rating as RatingKeys] = {
        ballastSpeedKts: parse(optimizedSpeeds[rating as RatingKeys].ballastSpeedKts),
        ladenSpeedKts: parse(optimizedSpeeds[rating as RatingKeys].ladenSpeedKts),
      };
    }

    return res;
  }
};
